import { defineStore } from "pinia";
import { type OfficeOption } from "@/types/office";
import { type PartnerOption } from "@/types/partner";
import { type PlanOption } from "@/types/plans";

export const useStore = defineStore("main", {
  state: () => ({
    officeOptions: [] as OfficeOption[],
    partnerOptions: [] as PartnerOption[],
    planOptions: [] as PlanOption[],
  }),
});
